import React from 'react';
import styles from './RadioButton.module.scss';
import { isNullOrUndefined } from '../../helpers/object-helpers';

export interface IRadioButton {
  id: string;
  label: string;
  value: string;
  group: string;
  onChange?: (value: string) => void;
  checked?: boolean;
}

export default function RadioButton({ id, label, value, group, onChange, checked }: IRadioButton) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (!isNullOrUndefined(onChange)) onChange(event.target.value);
  }

  return (
    <div className={styles.radioButton}>
      <input
        id={id}
        type="radio"
        name={group}
        value={value}
        onChange={(event) => {
          handleChange(event);
        }}
        checked={checked}
      />
      <div className={styles.fakeRadioButton}></div>
      <label htmlFor={id}>{label}</label>
    </div>
  );
}
